<span class="d-block badge badge-info origem mt-1" *ngIf="pedido?.origem"
      [ngClass]="{'badge-danger' : pedido.doIfood, 'badge-warning': pedido.balcao,
                   'badge-dark' : pedido.doKeeta}">
        {{pedido.origem}}
</span>
